(function () {
  function updateQuantityLimit(sectionId, variantId) {
    if (!variantId || !window.__variantStock__) return;

    const stock = window.__variantStock__[variantId];
    if (stock == null) return;

    const qtyInput = document.getElementById(`Quantity-${sectionId}`);
    if (!qtyInput) return;

    // Set max stock
    qtyInput.setAttribute('max', stock);
    qtyInput.dataset.max = stock;

    // Prevent quantity from exceeding stock on initial load
    if (parseInt(qtyInput.value, 10) > stock) {
      qtyInput.value = stock;
    }

    // Refresh Dawn buttons state
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    // --------------------
    // Initial page load
    // --------------------
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const sectionId = productInfo.dataset.section;

      // Get currently selected variant ID
      const variantInput =
        productInfo.querySelector('input[name="id"]') ||
        productInfo.querySelector('select[name="id"]');

      if (variantInput) {
        updateQuantityLimit(sectionId, variantInput.value);
      }
    });

    // --------------------
    // Variant change
    // --------------------
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event.data.sectionId;
      const variantId = event.data.variant?.id;

      updateQuantityLimit(sectionId, variantId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();